import PrimaryButton from "@/shared/ui/PrimaryButton";
import { Input } from "@/shared/ui/input";
import { useLogin } from "@/features/auth/hooks/login/useLogin";
import styles from "./LoginForm.module.scss";

type LoginFormProps = {
  /** 로그인 성공 시 호출 — 예: 오버레이 시트 닫기. */
  onSuccess?: () => void;
};

const LoginForm = ({ onSuccess }: LoginFormProps) => {
  const { values, errors, isSubmitting, setId, setPassword, submit } = useLogin({
    onSuccess,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    void submit();
  };

  return (
    <form
      className={styles.loginForm}
      onSubmit={handleSubmit}
    >
      <Input
        label="아이디"
        placeholder="아이디를 입력하세요"
        value={values.id}
        onChange={setId}
        error={errors.id}
        clearable
        autoComplete="username"
      />

      <Input
        type="password"
        label="비밀번호"
        placeholder="비밀번호를 입력하세요"
        value={values.password}
        onChange={setPassword}
        error={errors.password}
        revealable
        autoComplete="current-password"
      />

      <PrimaryButton
        type="submit"
        loading={isSubmitting}
      >
        로그인
      </PrimaryButton>
    </form>
  );
};

export default LoginForm;
